import { HELP_CENTRE_LOCALISED_URL } from '@seek/shared-constants';
import { useTranslations } from '@vocab/react';
import { Heading, Text, Stack, Strong } from 'braid-design-system';
import React from 'react';

import { TextLink } from 'src/components';
import { TRACKING_CODES } from 'src/shared/constant';
import { useSite } from 'src/shared/hooks';
import type { SitesAll } from 'src/shared/types';

import translations from '../../../../.vocab';

const FormIntro = () => {
  const site: SitesAll = useSite();
  const { t } = useTranslations(translations);
  const typedSite = site as keyof typeof HELP_CENTRE_LOCALISED_URL;

  return (
    <Stack space="medium">
      <Heading level="3">
        <Strong>{t('Have an enquiry?')}</Strong>
      </Heading>
      <Text>{t('Send us a message using the form below')}</Text>
      <Text>
        {t('Search for answers in our Help Centre.', {
          TextLink: (children) => (
            <TextLink
              href={HELP_CENTRE_LOCALISED_URL[typedSite].en}
              tracking={TRACKING_CODES.can_help_centre_link_clicked}
              eventProperties={{
                eventName: 'content_element_pressed',
                currentPage: 'feedback success',
                siteSection: 'candidate contact us',
                linkName: 'candidate-help-centre-link-clicked',
                linkText: 'candidate help centre',
              }}
            >
              {children}
            </TextLink>
          ),
        })}
      </Text>
      <Text>
        {t('Are you an Employer?')}{' '}
        <TextLink
          href="/contactus"
          product="employer"
          tracking={TRACKING_CODES.contact_us_link_clicked}
          eventProperties={{
            eventName: 'content_element_pressed',
            currentPage: 'feedback success',
            siteSection: 'candidate contact us',
            linkName: 'contact-us-link-clicked',
            linkText: 'employer contact us',
          }}
        >
          {t('Contact us here')}
        </TextLink>
      </Text>
    </Stack>
  );
};

export default FormIntro;
